module.exports = __webpack_public_path__ + "img/who-3.50ac2413.png";